export interface ApiSearchReport {
    id: string;
    rev: string;
    type: string;
    organisation: string;
    name: string;
    description: string;
    run_by_roles: string[];
    roles: string[];
    relations: string[];
    createdDate: string;
    modifiedDate: string;
}

export function isApiSearchReport(data: any): data is ApiSearchReport {
    return data && (data.type === 'report' || data.type === 'reportTemplate');
}


export class SearchReport {
    id: string;
    rev: string;
    type: string;
    organisation: string;
    name: string;
    description: string;
    run_by_roles: string[];
    roles: string[];
    relations: string[];
    createdDate: string;
    modifiedDate: string;

    constructor(data: SearchReport) {
        Object.assign(this, data);
    }

    // Deserialize from API response
    static fromApiResponse(response: ApiSearchReport): SearchReport {
        if (!isApiSearchReport(response)) {
            throw new Error('Invalid report API response');
        }

        return new SearchReport({
            id: response.id,
            rev: response.rev,
            name: response.name,
            type: response.type,
            organisation: response.organisation,
            description: response.description,
            run_by_roles: response.run_by_roles,
            roles: response.roles,
            relations: response.relations,
            createdDate: response.createdDate,
            modifiedDate: response.modifiedDate,
        });
    }
}